import { createFileRoute } from '@tanstack/react-router';

import { Management } from '~/components/Header/navigation/subRoutes/Management';
import { ROLES } from '~/constants';
import { authoriseUser } from '~/features/auth/utils/authoriseUser';

export const Route = createFileRoute('/_app/management')({
    beforeLoad: ({ location }) => {
        authoriseUser(Object.values(ROLES), location);
        const content = 'ROUTE_TITLE.CRM_MANAGEMENT';
        return {
            meta: [
                {
                    content,
                    name: 'description',
                },
                {
                    content,
                    name: 'title',
                },
            ],
        };
    },
    component: () => <Management />,
});
